/**
 * Resolves the names shown on a bill/invoice header & footer.
 *
 * The `trade_name` override is a CRITICAL legal/GST identity field. It is only
 * honoured when the property is GST-enabled — if GST is off, the override is
 * ignored entirely and the hotel name is used, regardless of any stored value.
 *
 * When honoured and non-blank, `trade_name` becomes the primary name and the
 * hotel/brand name drops to a secondary line. Otherwise output is unchanged.
 *
 * @param {string} tradeName - hotelProfile.trade_name override (may be null/""/whitespace)
 * @param {string} hotelName - the document's existing hotel name
 * @param {boolean} gstEnabled - whether the property is GST-enabled
 * @returns {{ primary: string, secondary: string|null }}
 *   primary   -> big name slot + footer
 *   secondary -> small sub-line under the primary (null when no override)
 */
export const resolveBillingNames = (tradeName, hotelName, gstEnabled = false) => {
  const override = gstEnabled ? (tradeName || "").trim() : "";
  return {
    primary: override || hotelName,
    secondary: override ? hotelName : null,
  };
};
